<template>
  <div class="job-management">
    <jobManageTopbar @searchjob="searchjob" @addjobShowSwitch="addjobShowSwitch" :deleteList="deleteList" />
    <!-- 列表栏容器 -->
    <div class="job-info-table-container" v-bitmap="jobListGetResult">
      <jobList class="job-list" :jobData="jobData" v-show="total" @multipleDelete="multipleDelete"
        :menuData="menuData" />
    </div>
    <!-- 分页容器 -->
    <div class="job-info-pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
    </div>
    <addJob :addjobShow.sync="addjobShow" @addConfirm="addConfirm" v-show="addjobShow" ref="addjobShow" />
  </div>
</template>

<script>
import jobManageTopbar from "./components/job-manage-topbar/jobManageTopbar.vue";
import jobList from "./components/job-list/jobList.vue";
import addJob from "./components/add-job/addJob.vue";
export default {
  data() {
    return {
      jobListGetResult: "success",
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      addjobShow: false,
      total: 0,
      deleteList: [],
      jobData: [],
      jobName: "",
      menuData: [],
    };
  },
  components: {
    jobManageTopbar,
    jobList,
    addJob,
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.selectMenuBySchoolId();
    this.getSchoolJobList();
  },
  methods: {
    refresh() {
      this.total = 0;
      this.pageInfo = {
        pageSize: 10,
        pageNum: 1,
      };
      this.getSchoolJobList();
    },
    selectMenuBySchoolId() {
      let data = {
        schoolId: this.user.schoolId,
      };
      this.get(this.$url.selectMenuBySchoolId, data).then((res) => {
        // console.log("获取学校功能菜单列表==>", res);
        if (res.code != 200) {
          return this.$message.error("获取菜单列表失败");
        }
        let menuList = res.data;
        // 遍历menuList数组，将子菜单添加到对应的父菜单的childMenu属性中
        menuList.forEach((menu) => {
          menu["label"] = menu.menuName;
          menu["value"] = menu.id;
          const parentId = menu.parentId;
          const parentMenu = menuList.find((item) => item.id === parentId);
          if (parentMenu) {
            if (!parentMenu.childMenu) {
              parentMenu.children = [];
              parentMenu.childMenu = [];
            }
            // if (menu.menuType != "F") {
            //   parentMenu.children.push(menu);
            // }
            parentMenu.children.push(menu);
            parentMenu.childMenu.push(menu);
          }
        });

        // 使用 filter 方法过滤掉不需要的对象
        this.menuData = menuList.filter((menu) => menu.parentId === 0);
        // console.log("this.menuData==>", data);
      });
    },
    // 添加职务
    addConfirm(e) {
      this.post(this.$url.sertSchoolJob, {
        schoolId: this.user.schoolId,
        jobName: e.name,
      }).then((res) => {
        if (res.code != 200) return this.$message.error(res.msg);
        this.$message.success("添加成功");
        this.addjobShow = false;
        this.getSchoolJobList();
      });
    },
    multipleDelete(res) {
      // console.log(res);
      this.deleteList = res;
    },
    searchjob(e) {
      this.jobName = e;
      this.getSchoolJobList();
    },
    addjobShowSwitch(e) {
      this.addjobShow = e;
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getSchoolJobList();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getSchoolJobList();
    },
    getSchoolJobList() {
      // this.jobListGetResult = "loading";
      let data = {
        schoolId: this.user.schoolId,
        jobName: this.jobName,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      };
      this.get(this.$url.getSchoolJobList, data).then((res) => {
        // console.log("查询职务列表==>", res);
        if (res.code != 200) {
          this.jobListGetResult = "error";
          return this.$message.error("获取职务列表失败");
        }
        this.jobData = res.rows;
        this.total = res.total;
        this.total > 0
          ? (this.jobListGetResult = "success")
          : (this.jobListGetResult = "nullData");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./jobManagement.scss";
</style>
